import { mediaItems } from '@/mocks/home';

const mediaImages: Record<string, string> = {
  'media-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20awards%20celebration%20illustration%2C%20spotlight%20on%20stage%20with%20trophy%2C%20artistic%20decorative%20elements%2C%20warm%20golden%20and%20coral%20tones%2C%20elegant%20ceremony%20atmosphere%2C%20editorial%20style&width=800&height=500&seq=media-1&orientation=landscape',
  'media-2': 'https://readdy.ai/api/search-image?query=Stack%20of%20beautiful%20manhwa%20comic%20books%20with%20warm%20lighting%2C%20cozy%20reading%20nook%2C%20artistic%20flat%20lay%20arrangement%2C%20soft%20warm%20tones%2C%20editorial%20photography%20style%2C%20literary%20atmosphere&width=800&height=500&seq=media-2&orientation=landscape',
  'media-3': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20artist%20studio%20workspace%2C%20drawing%20tablet%20with%20illustration%20in%20progress%2C%20warm%20ambient%20lighting%2C%20sketch%20papers%20and%20art%20supplies%2C%20creative%20atmosphere%2C%20artistic%20editorial%20style&width=800&height=500&seq=media-3&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-950">媒体专区</h2>
          <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">专题与访谈</span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="group cursor-pointer rounded-lg overflow-hidden bg-background-100 border border-background-200/70">
              <div className="w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={mediaImages[item.coverSeq]}
                  alt={`韩漫网媒体 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <p className="text-xs text-foreground-500 mb-1">{item.date}</p>
                <h3 className="text-sm md:text-base font-heading text-foreground-900 group-hover:text-primary-500 transition-colors mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}